import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/home',
		name: 'Home',
		component: Home
	},
	{
		path: '/lottery',
		name: 'Lottery',
		component: () => import('../views/Lottery.vue')
	}, {
		path: '/mine',
		name: 'Mine',
		component: () => import('../views/Mine.vue')
	},

]

const router = new VueRouter({
	routes
})

export default router
